class QuickBuy extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()
    this.triggerAttribute = '[data-quick-buy-external-el="trigger"]'
    this.sectionId = 'quick-buy'
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, `load`, this.setupModal.bind(this))
    this.listeners.add(document, `click`, this.handleTrigger.bind(this))
    this.listeners.add(
      this.els.close.element,
      `click`,
      this.handleClose.bind(this),
    )

    this.addEventListener('backInStockSubscribed', this.handleClose.bind(this))

    this.listeners.add(this, `click`, this.handleOverlayClose.bind(this))

    document.addEventListener(
      'quickbuy:update-product',
      this.handleBuild.bind(this),
    )
  }

  setupModal () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.handleClose.bind(this),
    )
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(this.triggerAttribute)
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle(this.sectionId, trigger.dataset.productUrl)
      .then(res => {
        const sectionHTML = window.BAO.sectionRenderer.getInnerHtml(res)

        this.els.content.element.innerHTML = sectionHTML

        this.handleOpen()

        window.drawers.activeDrawerKey = ''
      })
      .catch(() => {
        this.close()
      })
  }

  async handleBuild (event) {
    const productUrl = event.detail.name

    await window.BAO.sectionRenderer
      .fetchSingle(this.sectionId, productUrl)
      .then(res => {
        const sectionHTML = window.BAO.sectionRenderer.getInnerHtml(res)

        this.els.content.element.innerHTML = sectionHTML

        this.handleOpen()
      })
      .catch(() => {
        this.close()
      })
  }

  handleOverlayClose (event) {
    if (event.target === this) {
      this.handleClose()
    }
  }

  handleClose () {
    this.close()
    document.body.style.overflow = 'visible'
  }

  handleOpen () {
    this.showModal()
    document.body.style.overflow = 'hidden'
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy, {
    extends: 'dialog',
  })
}
